// src/hooks/useDateSpecialReport.js
import {useQuery} from 'react-query';
import {fetchDateSpecialReportList} from "../api/dateSpecialReportApi";

export const useDateSpecialReport = () => {
    return useQuery(['dateSpecialReport'], () => fetchDateSpecialReportList(), {
        refetchOnWindowFocus: false, // 根據需求調整
    });
};
